module.exports = __webpack_public_path__ + "static/img/logo_transferh_full.e3a5028.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_transferh_full.png
// module id = 10
// module chunks = 0